import { InAppMessagePresentationContext } from "../../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageHtmlContentResolver } from "../../html/InAppMessageHtmlContentResolver"
import { InAppMessageUi } from "../../InAppMessageUi"
import { HtmlInAppMessageView } from "../html/HtmlInAppMessageView"
import { InAppMessageView } from "../InAppMessageView"
import { InAppMessageViewStatus } from "../InAppMessageViewStatus"
import { InAppMessageViewFactory } from "./InAppMessageViewFactory"
import { HtmlInAppMessageDOMManager } from "../html/HtmlInAppMessageDOMManager"
import { HtmlInAppMessageRenderer } from "../html/HtmlInAppMessageRenderer"
import { InAppMessageBridgeFactory } from "../../html/InAppMessageBridgeFactory"

export class HtmlInAppMessageViewFactory implements InAppMessageViewFactory {
  constructor(
    private readonly htmlResolver: InAppMessageHtmlContentResolver,
    private readonly bridgeFactory: InAppMessageBridgeFactory
  ) {}

  static create(
    htmlResolver: InAppMessageHtmlContentResolver,
    bridgeFactory: InAppMessageBridgeFactory
  ): HtmlInAppMessageViewFactory {
    return new HtmlInAppMessageViewFactory(htmlResolver, bridgeFactory)
  }

  create(context: InAppMessagePresentationContext, ui: InAppMessageUi): InAppMessageView | null {
    const viewStatus = new InAppMessageViewStatus()

    const domManager = new HtmlInAppMessageDOMManager()
    const renderer = new HtmlInAppMessageRenderer(domManager)
    const bridge = this.bridgeFactory.create(ui)

    return new HtmlInAppMessageView(context, ui, viewStatus, this.htmlResolver, renderer, bridge)
  }

  supports(context: InAppMessagePresentationContext): boolean {
    return context.message.html !== null && context.message.layout.displayType === "HTML"
  }
}
